import { render, staticRenderFns } from "./TableCol.vue?vue&type=template&id=6bd5f1bb&scoped=true"
import script from "./TableCol.vue?vue&type=script&lang=js"
export * from "./TableCol.vue?vue&type=script&lang=js"
import style0 from "./TableCol.vue?vue&type=style&index=0&id=6bd5f1bb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_6m5rqjauvbyej62p7eiecas4wq/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bd5f1bb",
  null
  
)

export default component.exports